import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ApplicationRouter, Route } from '@aviv-unified-frontend/runtime/router';
import { Brand } from './brands';
import { BrandConfigurationProvider } from './contexts/brandConfiguration/provider';
import Head from './components/Head';
import { useI18n } from './hooks/useI18n';
const Template = Brand.template;
export const App = () => {
    useI18n('nutzungsdauer');
    return (_jsxs(BrandConfigurationProvider, { value: Brand, children: [_jsx(Head, {}), _jsx(ApplicationRouter, { children: _jsx(Route, { path: "/", element: _jsx(Template, { name: "generic" }) }) })] }));
};
